import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-gray-500 truncate" }
const _hoisted_2 = { class: "mt-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-lg md:text-3xl font-semibold text-gray-900"
}

import Skeleton from "@/components/skeletons/Skeleton.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  title: String,
  value: {},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dt", _hoisted_1, _toDisplayString(__props.title), 1),
    _createElementVNode("dd", _hoisted_2, [
      (__props.value !== undefined)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.value), 1))
        : (_openBlock(), _createBlock(Skeleton, {
            key: 1,
            class: "h-8"
          })),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})